<div class="market-cap-filter">
  <nz-tree
    *ngIf="!isLoading"
    [nzData]="marketCapData"
    nzCheckable
    nzMultiple
    [nzShowExpand]="false"
    [nzCheckedKeys]="selectedMarketCaps"
    nzSelectedKeys="null"
    (nzCheckBoxChange)="onCheckboxChange($event)"
    [nzTreeTemplate]="nzTreeTemplate"
  >
    <ng-template #expandedIconTpl let-node>
      <span></span>
    </ng-template>
  </nz-tree>
  <ng-template #nzTreeTemplate let-node let-origin="origin">
    <div class="custom-tree-node" (change)="onCheckboxChange($event)">
      <span>{{ node.origin.title }}</span>
      <span>{{ node.origin.count }}</span>
    </div>
  </ng-template>
</div>

<app-custom-skeleton
  *ngIf="isLoading"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="industry-skeleton-title"
></app-custom-skeleton>
